import Plugin from './plugin'
export default Plugin


